import React from 'react';
import PropTypes from 'prop-types';

import resources from 'react/containers/pages/TicketDetails/ticketDetailsResources';
import { resourceFrom, formatDate } from 'react/containers/pages/TicketDetails/ticketDetailsUtils';

const changeAllDynamicAtt = (stringDynamicAtt = '') => (
  stringDynamicAtt.replace(/@(.*?)@/g, (_, defaultValue) => (
    resourceFrom(defaultValue)
  ))
);

function AttachmentChatItem(props) {
  const { chat } = props;

  const renderChat = () => (
    <>
      <span className="attachmentsSection__messageSufix">{chat.get('fromName')}</span>
      <span className="attachmentsSection__messageSufix">
        {` ${resourceFrom(resources.chatAt)} ${formatDate(chat.get('sentDate'))} > `}
      </span>
      <span>{chat.get('message')}</span>
    </>
  );

  const renderTicketMessage = () => {
    const messageTranslated = changeAllDynamicAtt(chat.get('message'));
    const sentDateFormated = formatDate(chat.get('sentDate'));

    const message = ` ${messageTranslated} ${resourceFrom(resources.chatAt)} ${sentDateFormated}`;

    return (
      <div className="attachmentsSection__messageTicket">
        <span>{message}</span>
      </div>
    );
  };

  const handleToRenderMessageType = () => {
    if (chat.get('needTranslation')) {
      return renderTicketMessage();
    }

    return renderChat();
  };

  return (
    <div className="attachmentsSection__messageContent">
      {handleToRenderMessageType()}
    </div>
  );
}

AttachmentChatItem.propTypes = {
  chat: PropTypes.object.isRequired
};

export default AttachmentChatItem;
